export default "__VITE_ASSET__kYu35Hh6__"